import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
//import OrderProducts from './pages/OrderProducts';
import ProductPage from './pages/ProductPage';
import Dropbox from "./pages/Dropbox";
import ContactUs from "./pages/ContactUs";
import MyOrders from "./pages/MyOrders";
import CreateOrder from './pages/CreateOrder';
import Auth from './pages/Auth';             // login user normal
import AdminLogin from "./pages/admin-login"; // login admin cu cod secret
import PrivateRoute from './components/PrivateRoute';
import EditOrder from "./pages/EditOrder";
import OrderDetails from "./pages/OrderDetails";
import AdminDashboard from "./pages/AdminDashboard";
import EditOrderAdmin from './pages/EditOrderAdmin'; // import nou pentru admin edit page
import ManageClients from "./pages/ManageClients";
import AdminVerify from "./pages/AdminVerify";
import Account from "./pages/Account";
import Gallery from "./pages/Gallery";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/gallery" element={<Gallery />} />
        {/* <Route path="/orderproducts" element={<OrderProducts />} /> */}
        <Route path="/product/:slug" element={<ProductPage />} />
        <Route path="/dropbox" element={<Dropbox />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/edit-order/:id" element={<EditOrder />} />
        <Route path="/orders/:id" element={<OrderDetails />} />

        <Route path="/admin-verify" element={<AdminVerify />} />

        {/* Login separat pentru admin */}
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* Dashboard admin, protejat cu rol "admin" */}
        <Route
          path="/admin"
          element={
            <PrivateRoute roleRequired="admin">
              <AdminDashboard />
            </PrivateRoute>
          }
        />

        {/* Login user normal */}
        <Route path="/auth" element={<Auth />} />

        {/* Pagini protejate pentru user, fara rol explicit */}
        <Route
          path="/my-orders"
          element={
            <PrivateRoute>
              <MyOrders />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-order"
          element={
            <PrivateRoute>
              <CreateOrder />
            </PrivateRoute>
          }
        />


        <Route
          path="/admin/edit-order/:orderId"
          element={
            <PrivateRoute roleRequired="admin">
              <EditOrderAdmin />
            </PrivateRoute>
          }
        />


        <Route
          path="/manage-clients"
          element={
            <PrivateRoute roleRequired="admin">
              <ManageClients />
            </PrivateRoute>
          }
        />




        <Route
          path="/account"
          element={
            <PrivateRoute>
              <Account />
            </PrivateRoute>
          }
        />

      </Routes>
    </Router>
  );
}

export default App;
